export function getSpaceRoleDisplayName(role: string) {
  switch (role) {
    case "owner":
      return "Owner";
    case "admin":
      return "Admin";
    case "member":
      return "Content Manager";
    case "limited_member":
      return "Member";
    default:
      return "Public Guest";
  }
}
